import { ApiResult, post } from '@/utils/api';
import { ResultModel } from '@/model/viewModel';
import { HomepageConfig } from '@/model/homeConfig';
import { DefinedDataModel } from '@/model/definedData';
import { GetSelfPickTimeListResponse } from '@/model/shopModel';

export const fetchShopList = (data: any): Promise<ApiResult<ResultModel<any>>> =>
  post<ResultModel<any>>('/dim/shop/select', data);

export const fetchTableByCode = (data: any): Promise<ApiResult<any>> =>
  post<any>('/dim/table/searchCode', data);

// 获取首页配置
export const fetchHomepageConfig = (data: any): Promise<ApiResult<ResultModel<HomepageConfig>>> =>
  post<ResultModel<HomepageConfig>>('/dim/definedData/select', data);

export const fetchCustomerCount = (data: any): Promise<ApiResult<ResultModel<any>>> =>
  post<ResultModel<any>>('/shop/table/customer/count', data);

// 获取自定义数据
export const getDefinedDataList = (data: any): Promise<ApiResult<ResultModel<DefinedDataModel>>> =>
  post<ResultModel<DefinedDataModel>>('/dim/definedData/select', data);

export const getSelfPickTimeList = (data: any): Promise<ApiResult<GetSelfPickTimeListResponse[]>> =>
  post<GetSelfPickTimeListResponse[]>('/dim/shop/selfPickTime', data);
